import { customInstance } from '@/features/auth/axios-config'
import {
  RequestFilters,
  SuccessResponsePaginatedResponseResponseUser,
} from '@/schema'
import { mergeTablePaginationParams } from '@/utils'

export type SecondParameter<T extends (...args: never) => unknown> =
  Parameters<T>[1]

const API_ENDPOINT_USERS = '/admin/v1/users'

export const userApi = {
  /**
   * Fetches a list of users
   * @param data - Filter and pagination data
   * @returns Promise with user list data and pagination info
   */
  getUserList: async (
    data: Partial<RequestFilters> = {},
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal
  ): Promise<SuccessResponsePaginatedResponseResponseUser> => {
    const requestBody = mergeTablePaginationParams(data)

    return customInstance<SuccessResponsePaginatedResponseResponseUser>(
      {
        method: 'post',
        url: `${API_ENDPOINT_USERS}/list`,
        data: requestBody,
        signal,
      },
      options
    )
  },
}
